import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { useCloseTracking } from '../../useCloseTracking';
import DealerAd from '../..';

import s from './Adhesion.scss';

export interface Props {
  realEstateId: string;
}

const AdhesionAdUnit: React.FC<Props> = ({ realEstateId }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [passedOffer, setPassedOffer] = useState<any>(undefined);
  const [isHidden, setIsHidden] = useState(false);
  const isMounted = useIsMounted();

  const iframeCommandHandler = useCallback((command, data) => {
    switch (command) {
      case 'show-adhesion':
        setIsVisible(true);
        setPassedOffer(data);
        break;
    }
  }, []);

  const closeHandler = useCloseTracking(passedOffer, realEstateId, {
    iframeCommandHandler,
    onCloseStart: async () => {
      await yieldToMainAsync();
      setIsHidden(true);
    },
  });

  if (isHidden || !isMounted) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="AdhesionAdUnit">
      <div className={cn(s['root'], isVisible && s['visible'])}>
        <DealerAd
          disableLazy
          className={s['unit']}
          realEstateId={realEstateId}
          extraParams={
            process.env.NODE_ENV === 'development'
              ? {
                  forcefixture: 'adhesion',
                }
              : {}
          }
        />
        <IconButton
          className={s['close']}
          aria-label={t('common.hideAdvertisement')}
          icon={Close}
          size={'small'}
          onClick={closeHandler}
        />
      </div>
    </ErrorBoundary>
  );
};
AdhesionAdUnit.displayName = 'AdhesionAdUnit';

export default AdhesionAdUnit;
